import { Box, Container, Typography, Snackbar, Alert } from '@mui/material';
import { useBossBabyChatLogSessionList } from './useBossBabyChatLogSessionList';
import BossBabyChatLog from '@/templates/BossBabyChatLog';

/**
 * 보스베이비 채팅 로그 세션 리스트 페이지
 *
 * @description 보스베이비 채팅 세션 목록을 조회하고 관리하는 페이지
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-29
 */
export default function BossBabyChatLogSessionList() {
  const {
    sessions,
    loading,
    error,
    pagination,
    filters,
    snackbarOpen,
    snackbarMessage,
    handlePageChange,
    handleLimitChange,
    handleFilterChange,
    handleResetFilters,
    handleRefresh,
    handleViewSession,
    handleSnackbarClose,
  } = useBossBabyChatLogSessionList();

  return (
    <Container maxWidth="xl">
      <Box
        display="flex"
        justifyContent="space-between"
        gap={2}
        alignItems="end"
        mb={2}
      >
        <Typography component="h1" variant="h5" fontWeight="bold" gutterBottom>
          보스베이비 채팅 로그
        </Typography>
      </Box>

      <BossBabyChatLog.SessionList
        sessions={sessions}
        loading={loading}
        error={error}
        pagination={pagination}
        filters={filters}
        snackbarOpen={snackbarOpen}
        snackbarMessage={snackbarMessage}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        onFilterChange={handleFilterChange}
        onResetFilters={handleResetFilters}
        onRefresh={handleRefresh}
        onViewSession={handleViewSession}
        onSnackbarClose={handleSnackbarClose}
      />

      {/* 에러/성공 메시지 스낵바 */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={
            snackbarMessage.includes('실패') ||
            snackbarMessage.includes('에러') ||
            snackbarMessage.includes('Failed')
              ? 'error'
              : 'success'
          }
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
}









